"use strict";

var _FieldCheckbox = require("./FieldCheckbox");

var _FieldCheckbox2 = _interopRequireDefault(_FieldCheckbox);

var _FieldInput = require("./FieldInput");

var _FieldInput2 = _interopRequireDefault(_FieldInput);

var _FieldPassword = require("./FieldPassword");

var _FieldPassword2 = _interopRequireDefault(_FieldPassword);

var _FieldRadioButton = require("./FieldRadioButton");

var _FieldRadioButton2 = _interopRequireDefault(_FieldRadioButton);

var _FieldSelect = require("./FieldSelect");

var _FieldSelect2 = _interopRequireDefault(_FieldSelect);

var _FieldSubmit = require("./FieldSubmit");

var _FieldSubmit2 = _interopRequireDefault(_FieldSubmit);

var _FieldTextarea = require("./FieldTextarea");

var _FieldTextarea2 = _interopRequireDefault(_FieldTextarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldTypes = {
  checkbox: _FieldCheckbox2.default,
  number: _FieldInput2.default,
  password: _FieldPassword2.default,
  radioButton: _FieldRadioButton2.default,
  submit: _FieldSubmit2.default,
  text: _FieldInput2.default,
  textarea: _FieldTextarea2.default,
  select: _FieldSelect2.default
};

module.exports = FieldTypes;


//////////////////
// WEBPACK FOOTER
// ./~/reactjs-components/lib/Form/FieldTypes.js
// module id = 1300
// module chunks = 2